import Color from '../Color.mjs'
import superMeta from '../_COMPONENT/metaComponentNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.DARK_GREEN,
    mapProp: 'map',
    name: '子系统实例',
    ownerIdProp: 'ssId',
    ownerTextProp: 'ssName',
    ownerType: 'SS',
    textProp: 'ssInsName',
    type: 'SSINS',
}

